<template>
    <a-form :form="form">
        <a-form-item label="Partner Name">
            <a-input autocomplete="off" trim type="text" v-model="form.name" />
        </a-form-item>
        <div class="d-flex gap-5">
            <a-form-item label="Discount Rate (0-100)">
                <a-input type="number" v-model="form.discount" />
            </a-form-item>
            <a-form-item label="Coupon Count">
                <a-input type="number" v-model="form.count" />
            </a-form-item>
            <a-form-item label="Coupon Code Length">
                <a-input type="number" v-model="form.codeLength" />
            </a-form-item>
        </div>

        <a-form-item label="Coupon Code Prefix (eg: APPSUMO-)">
            <a-input trim type="text" v-model="form.prefix" />
        </a-form-item>
        <a-form-item label="Coupon Expire Date">
            <a-date-picker style="width: 100%" v-model="form.endDate" />
        </a-form-item>
    </a-form>
</template>

<script>
export default {
    name: "MultiCreateCoupon",
    data() {
        return {
            form: _.cloneDeep(this.value),
        };
    },
    props: {
        value: {
            type: Object,
            default: () => ({
                name: "",
                discount: 10,
                count: 10,
                codeLength: 4,
                endDate: null,
                prefix: null,
            }),
        },
    },
    watch: {
        form: {
            handler: function (val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style scoped></style>
